export default __webpack_public_path__ + "static/media/login.17212428.png";